import React from "react";
import {
  HardHat,
  Wind,
  Trees,
  Wrench,
  Home,
  Sparkle,
  Hammer,
  Briefcase,
} from "lucide-react";

const industries = [
  { icon: HardHat, label: "Roofing" },
  { icon: Wind, label: "HVAC" },
  { icon: Trees, label: "Landscaping" },
  { icon: Wrench, label: "Plumbing" },
  { icon: Home, label: "Real Estate" },
  { icon: Sparkle, label: "Med Spas" },
  { icon: Hammer, label: "Home Services" },
  { icon: Briefcase, label: "Service Businesses" },
];

export default function IndustryBand() {
  return (
    <section
      id="who-its-for"
      className="relative py-14 sm:py-16 lg:py-20 border-y border-white/5 bg-[#070707]"
      data-testid="industries-section"
    >
      <div className="max-w-7xl mx-auto px-5 sm:px-6 lg:px-8">
        <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-6 reveal">
          <div>
            <div className="text-[10px] font-mono uppercase tracking-[0.3em] text-[#39FF14]">
              <span className="inline-block w-6 h-px bg-[#39FF14] align-middle mr-2" />
              Who this is for
            </div>
            <h2 className="mt-3 text-2xl sm:text-3xl md:text-4xl font-bold tracking-tight text-white max-w-xl">
              Built for{" "}
              <span className="gradient-text-green">service businesses</span>{" "}
              that run on inbound.
            </h2>
          </div>
          <p className="text-sm text-zinc-500 max-w-md leading-relaxed">
            If leads, calls, and bookings drive your revenue — we engineer the
            AI systems that capture every one of them.
          </p>
        </div>

        <div
          className="mt-9 grid grid-cols-2 sm:grid-cols-4 lg:grid-cols-8 gap-3 reveal"
          data-testid="industries-grid"
        >
          {industries.map(({ icon: Icon, label }, i) => (
            <div
              key={label}
              className="group relative flex flex-col items-center justify-center gap-2 py-5 px-3 rounded-xl border border-white/5 bg-white/[0.015] hover:border-[#39FF14]/25 hover:bg-white/[0.03] hover:-translate-y-0.5 transition-all duration-300"
              data-testid={`industry-${i + 1}`}
            >
              <div className="w-9 h-9 rounded-lg bg-[#39FF14]/8 border border-[#39FF14]/20 flex items-center justify-center text-[#39FF14] group-hover:scale-110 transition-transform">
                <Icon className="w-4 h-4" strokeWidth={1.6} aria-hidden="true" />
              </div>
              <span className="text-[11px] sm:text-xs text-zinc-300 text-center tracking-tight leading-tight">
                {label}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
